import { makeStyles } from '@material-ui/core'
import React from 'react'
import { tokens } from './tokens'
import { Container } from './Container'
import { SectionTitle } from './SectionTitle'
import { Button } from './Button'

const useStyles = makeStyles(() => ({
    intro: { padding: '70px 0 60px', textAlign: 'center' },
    text: {
        maxWidth: 900,
        margin: '0 auto 30px',
        color: tokens.colorTextLight,
        fontSize: '1.02rem',
    },
}))

export function Intro() {
    const classes = useStyles()
    return (
        <section className={classes.intro}>
            <Container>
                <SectionTitle>
                    Leading PCBA Test Fixtures Manufacturer Delivering Innovative PCB Test Solutions
                </SectionTitle>
                <p className={classes.text}>
                    SLS is your trusted partner for PCBA test automation services, delivering
                    customized testing solutions tailored to your manufacturing requirements. We
                    specialize in designing and developing custom test fixtures, mechanical and
                    pneumatic fixtures, functional test systems (FCT), in-circuit test systems
                    (ICT), and embedded test solutions. Our advanced automation test fixtures and
                    industry-leading software ensure accurate, error-free testing while improving
                    efficiency, reliability, and production quality.
                </p>
                <div>
                    <Button href="#why-choose">Read More</Button>
                </div>
            </Container>
        </section>
    )
}
